import {
	ChatBubbleLeftRightIcon as ChatOutline,
	DocumentTextIcon as DocOutline,
	Cog6ToothIcon as CogOutline,
} from "@heroicons/react/24/outline";

import {
	ChatBubbleLeftRightIcon as ChatSolid,
	DocumentTextIcon as DocSolid,
	Cog6ToothIcon as CogSolid,
} from "@heroicons/react/24/solid";

import { useNavigate, useLocation } from "react-router-dom";

export default function NavBar() {
	const navigate = useNavigate();
	const location = useLocation();

	const menu = [
		{
			id: "chats",
			label: "Chats",
			path: "/WhatsApp/Chat",
			outline: ChatOutline,
			solid: ChatSolid,
		},
		{
			id: "templates",
			label: "Templates",
			path: "/WhatsApp/Templates",
			outline: DocOutline,
			solid: DocSolid,
		},
		{
			id: "settings",
			label: "Settings",
			path: "/WhatsApp/Settings",
			outline: CogOutline,
			solid: CogSolid,
		},
	];

	return (
		<div className="w-[70px] bg-[#f0f2f5] border-r flex flex-col items-center py-4 gap-4">
			{menu.map((item) => {
				const isActive = location.pathname === item.path;
				const Icon = isActive ? item.solid : item.outline;

				return (
					<button
						key={item.id}
						onClick={() => navigate(item.path)}
						title={item.label}
						className={`w-10 h-10 flex items-center justify-center rounded-xl transition
							${
								isActive
									? "bg-white shadow-sm text-[#0b5cff]"
									: "text-gray-400 hover:text-gray-600 hover:bg-white hover:shadow-sm"
							}
						`}
					>
						<Icon className="w-5 h-5" />
					</button>
				);
			})}
		</div>
	);
}
